export default __webpack_public_path__ + "static/media/blue-right.9799cee3.svg";